import '../../styles/Form.css';
import "es6-shim";
import * as React from 'react';
import { ILabelSelect } from '../../services/Language/Types';
import Select from 'react-select'

interface IFormInputProps {
    value: string | number,
    options: ILabelSelect[],
    placeholder?: string,
    noOptionsMessage?: string;
    isInvalid?: boolean;
    onBlur?: () => void;
    onFocus?: () => void;
    onChange?: (selected: string | number) => void,
}

const customStyles = (isInvalid: boolean) => {

    const getBorderStyle = (isFocused) => {
        let color = isFocused ? "#a6d0f0" : "#ccc";
        if (isInvalid) {
            color = "red";
        }

        return "1px solid " + color + "!important";
    }
    return {
        option: (provided, state) => ({
            ...provided,
            fontSize: "30px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            textAlign: "center",
            backgroundColor: state.isSelected
                ? provided.backgroundColor
                : null
        }),
        input: (styles, style) => ({ ...styles, textAlign: "center", fontStyle: "30px", padding: "10px 16px" }),
        control: (styles, state) => ({
            ...styles,
            fontSize: "30px",
            height: "75px",
            borderColor: "",
            border: getBorderStyle(state.isFocused),
            boxShadow: "0",
            borderRadius: "6px",
            boxSizing: "border-box"
        })
    }
};
export const SelectControl = (props: IFormInputProps) => {
    const valueObject: ILabelSelect = props.options.firstOrDefault(x => x.value === props.value) || null;

    const selectProps = {
        options: props.options,
        styles: customStyles(props.isInvalid),
        placeholder: props.placeholder,
        value: valueObject,
        onChange: (selectedOption: ILabelSelect) => props.onChange(selectedOption.value),
    }

    if (props.noOptionsMessage) {
        selectProps["noOptionsMessage"] = () => props.noOptionsMessage
    }

    return (
        <Select
            {...selectProps}
            isSearchable={false}
            onFocus={(e) => { e.stopPropagation(); props.onFocus && props.onFocus() }}
        />
    );
}


// WEBPACK FOOTER //
// ./src/components/FormControls/SelectControl.tsx